import { STORAGE_KEYS } from '~constants'

/**
 * 로그인 성공 시 해당 함수를 호출하여 로컬스토리지에 토큰을 저장합니다.
 */
export const setToken = (accessToken: string) => {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('window is undefined'))
  }

  localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken)
  // On localStorage.setItem, the storage event is only triggered on other tabs and windows.
  // So we manually dispatch a storage event to trigger the subscribe function on the current window as well.
  window.dispatchEvent(
    new StorageEvent('storage', { key: STORAGE_KEYS.ACCESS_TOKEN, newValue: accessToken })
  )

  return Promise.resolve({ accessToken })
}

export const setGuestToken = (accessToken: string, anonymous_account_id: number) => {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('window is undefined'))
  }

  localStorage.setItem(STORAGE_KEYS.GUEST_TOKEN, accessToken)
  localStorage.setItem(STORAGE_KEYS.GUEST_ACCOUNT_ID, JSON.stringify(anonymous_account_id))

  // On localStorage.setItem, the storage event is only triggered on other tabs and windows.
  // So we manually dispatch a storage event to trigger the subscribe function on the current window as well.
  window.dispatchEvent(
    new StorageEvent('storage', { key: STORAGE_KEYS.GUEST_TOKEN, newValue: accessToken })
  )

  return Promise.resolve({ accessToken })
}

/**
 * 저장된 오너 세션을 비운다.
 *
 * setToken 과 마찬가지로 storage 이벤트를 직접 쏜다. localStorage 변경은 같은 탭에서
 * 이벤트를 발생시키지 않아, 이게 없으면 useLogInStatus 가 옛 값을 계속 들고 있는다.
 *
 * REFRESH_TOKEN 은 이 웹뷰가 발급받지 않는다 — SmartThings 앱이 /st/oauth2/token/ 으로
 * 받아 보관하고, 웹뷰는 진입할 때마다 새 OTP 로 세션을 받는 구조다. 그래서 여기서
 * 지우는 것은 혹시 남아 있을 값에 대한 방어일 뿐 실제로 도는 경로는 아니다.
 */
export const clearToken = () => {
  if (typeof window === 'undefined') {
    return
  }

  localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN)
  localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN)
  window.dispatchEvent(new StorageEvent('storage', { key: STORAGE_KEYS.ACCESS_TOKEN, newValue: null }))
}
